export default {
  company: "Công ty",
  share_holder: "Tổng quản trị",
  super_senior: "Quản trị",
  senior: "Cổ đông",
  master: "Tổng đại lý",
  agent: "Đại lý",
  member: "Hội viên",

  account_id: "Tên tài khoản",
  action: "Hoạt động",
  available_credit: "Tín dụng có sẵn",
  active: "Hoạt Động",
  account_balance: "Số dư tài khoản",
  agent_credit: "Đại lý tín dụng",
  authority: "Quyền",
  account_information: "Thông tin tài khoản",
  account_list: "Danh sách tài khoản",
  audit_by: "kiểm toán Bằng",
  add_account: "Thêm tài khoản",
  add_sub_account: "Thêm một tài khoản phụ",
  authority_option: "Ủy quyền Lựa chọn",
  account: "Tài khoản",
  access_log: "Nhật ký truy cập",
  account_log: "Nhật ký tài khoản",
  account_details: "Chi tiết tài khoản",
  action_by: "Hành động bởi",
  away_team_name: "Tên đội khách",
  amount: "Số tiền",
  account_before_balance: "Tài khoản trước số dư",
  account_after_balance: "Tài khoản sau khi số dư",
  cash_before_balance: "Before Balance",
  cash_after_balance: "After Balance",
  active_bet_list: "Danh sách cá cược tích cực",
  agent_win_all: "Đặc vụ chiến thắng tất cả",
  agent_win_half: "Đặc vụ thắng một nửa",
  agent_lose_all: "Đặc vụ mất tất cả",
  agent_lose_half: "Đặc vụ mất một nửa",
  accumulate_win: "Tích lũy Win",
  add_sub: "Thêm một tài khoản phụ",
  account_type: "Kiểu tài khoản",
  account_pt: "Tài khoản PT",
  account_min: "Tài khoản tối thiểu",
  away_score: "Tỷ số đội khách",
  add_secondary_full: "Thêm một tài khoản phụ",
  accumulate_balance: "Số dư lũy kế",
  away: "Khách",
  aa: "Hiệp 1: Khách | Cả trận: Khách",
  ad: "Hiệp 1: Khách | Cả trận: Hoà",
  ah: "Hiệp 1: Khách | Cả trận: Chủ nhà",
  anb: "Khách không bàn thắng",
  all: "Tất cả",
  account_existed: "Tài khoản tồn tại.",
  account_not_existed: "Tài khoản không tồn tại.",
  account_status: "Tình trạng tài khoản",
  account_block: "Khối tài khoản",
  account_unblock: "Bỏ chặn tài khoản",
  add_secondary: "Thêm tài khoản thứ 2",
  agent_bulk: "Đại lý lớn",

  balance: "Thăng bằng",
  bet: "Cá cược",
  block: "Bị chặn",
  blocked: "Bị chặn",
  back: "Back",
  bet_limit: "Giới hạn đặt cược",
  basketball: "Bóng rổ",
  baseball: "Bóng chày",
  bet_limit_log: "Lịch sử giới hạn cược",
  browser_agent: "Trình duyệt của đại lý",
  bet_limit_packages: "Gói giới hạn cược",
  ball: "Trái bóng",
  bet_count: "Số cược",
  bet_type: "Loại cược",
  bl: "Giới hạn đặt cược",
  basketball_min_bet: "@:ui.basketball @:ui.min_bet",
  basketball_max_bet: "@:ui.basketball @:ui.max_bet",
  basketball_max_per_match: "@:ui.basketball @:ui.max_per_match",
  baseball_min_bet: "@:ui.baseball @:ui.min_bet",
  baseball_max_bet: "@:ui.baseball @:ui.max_bet",
  baseball_max_per_match: "@:ui.baseball @:ui.max_per_match",
  bet_list: "Danh sách đặt cược",
  bs: "Tỉ số hòa",

  credit: "tín dụng",
  cm: "Ủy ban",
  close: "Đã đóng",
  cancel: "Hủy bỏ",
  continue: "Tiếp tục",
  created_on: "Đã được tạo ra",
  copy_and_create: "Sao chép và tạo",
  copy: "Sao chép",
  confirm_password: "Xác nhận mật khẩu",
  confirm_security_code: "Confirm security code",
  contact_phone: "Điện thoại",
  contact_email: "Email",
  cash_balance: "Số dư tiền mặt",
  currency: "Tiền tệ",
  credit_limit: "Giới hạn tín dụng",
  credit_balance: "Tín dụng / Số dư",
  commission: "Uỷ ban",
  correct_score: "Tỷ số chính xác",
  commission_log: "Lịch sử hoa hồng",
  current_balance: "Số dư hiện tại",
  cancelled_bet_list: "Danh sách đặt cược bị hủy",
  category: "thể loại",
  copy_to_bottom: "Sao chép xuống dưới",
  comm_sportsbook_hdp_a: "Kèo A",
  comm_sportsbook_hdp_b: "Kèo B",
  comm_sportsbook_hdp_c: "Kèo C",
  comm_sportsbook_hdp_d: "Kèo D",
  comm_sportsbook_hdp_e: "Kèo E",
  comm_sportsbook_hdp_f: "Kèo F",
  comm_sportsbook_hdp_g: "Kèo G",
  comm_sportsbook_hdp_h: "Kèo H",
  comm_sportsbook_hdp_i: "Kèo I",
  comm_sportsbook_hdp_j: "Kèo J",
  comm_sportsbook_1x2: "1X2",
  comm_sportsbook_others: "Khác",
  comm_sportsbook_hdp_packages: "Gói kèo",
  comm_slots: "Xèng",
  comm_casino: "Sòng bạc trực tuyến",
  comm_lotto: "Xổ số",
  comm_keno: "Trò chơi số keno",
  comm_cockfight: "đá gà",
  comm_lottery_1d: "Xổ số 1D",
  comm_lottery_2d: "Xổ số 2D",
  comm_lottery_3d: "Xổ số 3D",
  comm_lottery_4d: "Xổ số 4D",
  completed: "xổ số",
  clean_sheet: "Sạch lưới",
  cockfight: "Đá gà",
  cockfight_bet_limit_packages: "Giới hạn Gói cược đá gà",

  combine: {
    bet_limit_A: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_B: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_C: "Limit C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_D: "Limit D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_E: "Limit E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_F: "Limit F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_G: "Limit G (@:ui.min = 500 @:ui.max = 30000)",

    bet_limit_KRWA: "Limit A (@:ui.min = 1,500 @:ui.max = 200,000)",
    bet_limit_KRWB: "Limit B (@:ui.min = 2,000 @:ui.max = 200,000)",
    bet_limit_KRWC: "Limit C (@:ui.min = 2,000 @:ui.max = 400,000)",
    bet_limit_KRWD: "Limit D (@:ui.min = 4,000 @:ui.max = 800,000)",
    bet_limit_KRWE: "Limit E (@:ui.min = 4,000 @:ui.max = 2,000,000)",
    bet_limit_KRWF: "Limit F (@:ui.min = 4,000 @:ui.max = 4,000,000)",
    bet_limit_KRWG: "Limit G (@:ui.min = 4,000 @:ui.max = 6,000,000)",

    bet_limit_CNYA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_CNYB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_CNYC: "Limit C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_CNYD: "Limit D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_CNYE: "Limit E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_CNYF: "Limit F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_CNYG: "Limit G (@:ui.min = 500 @:ui.max = 30000)",

    bet_limit_HKDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_HKDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_HKDC: "Limit C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_HKDD: "Limit D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_HKDE: "Limit E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_HKDF: "Limit F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_HKDG: "Limit G (@:ui.min = 500 @:ui.max = 30000)",

    bet_limit_SGDA: "Limit A (@:ui.min = 1 @:ui.max = 100)",
    bet_limit_SGDB: "Limit B (@:ui.min = 1 @:ui.max = 200)",
    bet_limit_SGDC: "Limit C (@:ui.min = 5 @:ui.max = 500)",
    bet_limit_SGDD: "Limit D (@:ui.min = 5 @:ui.max = 1,000)",
    bet_limit_SGDE: "Limit E (@:ui.min = 10 @:ui.max = 2,000)",
    bet_limit_SGDF: "Limit F (@:ui.min = 5 @:ui.max = 5,000)",
    bet_limit_SGDG: "Limit G (@:ui.min = 5 @:ui.max = 10,000)",
    
    bet_limit_VNDA: "Limit A (@:ui.min = 10 @:ui.max = 2,000)",
    bet_limit_VNDB: "Limit B (@:ui.min = 10 @:ui.max = 3,000)",
    bet_limit_VNDC: "Limit C (@:ui.min = 40 @:ui.max = 5,000)",
    bet_limit_VNDD: "Limit D (@:ui.min = 80 @:ui.max = 25,000)",
    bet_limit_VNDE: "Limit E (@:ui.min = 80 @:ui.max = 50,000)",
    bet_limit_VNDF: "Limit F (@:ui.min = 80 @:ui.max = 100,000)",
    bet_limit_VNDG: "Limit G (@:ui.min = 80 @:ui.max = 150,000)",
	
	  bet_limit_MYRA: "Limit A (@:ui.min = 1 @:ui.max = 500)",
    bet_limit_MYRB: "Limit B (@:ui.min = 5 @:ui.max = 500)",
    bet_limit_MYRC: "Limit C (@:ui.min = 10 @:ui.max = 1,000)",
    bet_limit_MYRD: "Limit D (@:ui.min = 10 @:ui.max = 2,500)",
    bet_limit_MYRE: "Limit E (@:ui.min = 100 @:ui.max = 5,000)",
    bet_limit_MYRF: "Limit F (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_MYRG: "Limit G (@:ui.min = 500 @:ui.max = 20,000)",
	
	  bet_limit_USDA: "Limit A (@:ui.min = 1 @:ui.max = 100)",
    bet_limit_USDB: "Limit B (@:ui.min = 1 @:ui.max = 125)",
    bet_limit_USDC: "Limit C (@:ui.min = 2 @:ui.max = 400)",
    bet_limit_USDD: "Limit D (@:ui.min = 5 @:ui.max = 1,500)",
    bet_limit_USDE: "Limit E (@:ui.min = 5 @:ui.max = 2,500)",
    bet_limit_USDF: "Limit F (@:ui.min = 5 @:ui.max = 5,000)",
    bet_limit_USDG: "Limit G (@:ui.min = 5 @:ui.max = 10,000)",
	
	  bet_limit_THBA: "Limit A (@:ui.min = 10 @:ui.max = 2,500)",
    bet_limit_THBB: "Limit B (@:ui.min = 50 @:ui.max = 5,000)",
    bet_limit_THBC: "Limit C (@:ui.min = 100 @:ui.max = 10,000)",
    bet_limit_THBD: "Limit D (@:ui.min = 100 @:ui.max = 50,000)",
    bet_limit_THBE: "Limit E (@:ui.min = 100 @:ui.max = 100,000)",
    bet_limit_THBF: "Limit F (@:ui.min = 100 @:ui.max = 200,000)",
    bet_limit_THBG: "Limit G (@:ui.min = 100 @:ui.max = 300,000)",
	
	  bet_limit_IDRA: "Limit A (@:ui.min = 5 @:ui.max = 1,000)",
    bet_limit_IDRB: "Limit B (@:ui.min = 20 @:ui.max = 1,500)",
    bet_limit_IDRC: "Limit C (@:ui.min = 25 @:ui.max = 3,000)",
    bet_limit_IDRD: "Limit D (@:ui.min = 50 @:ui.max = 15,000)",
    bet_limit_IDRE: "Limit E (@:ui.min = 50 @:ui.max = 30,000)",
    bet_limit_IDRF: "Limit F (@:ui.min = 50 @:ui.max = 60,000)",
    bet_limit_IDRG: "Limit G (@:ui.min = 50 @:ui.max = 100,000)",

    // comm_limit_A: "A (@:ui.hdp/@:ui.ou/@:ui.oe) 5%",
    // comm_limit_B: "B (@:ui.hdp/@:ui.ou/@:ui.oe) 6%",
    // comm_limit_C: "C (@:ui.hdp/@:ui.ou/@:ui.oe) 7%",
    // comm_limit_D: "D (@:ui.hdp/@:ui.ou/@:ui.oe) 8%",
    // comm_limit_E: "E (@:ui.hdp/@:ui.ou/@:ui.oe) 9%",
    // comm_limit_F: "F (@:ui.hdp/@:ui.ou/@:ui.oe) 10%",
    // comm_limit_G: "G (@:ui.hdp/@:ui.ou/@:ui.oe) 11%",
    // comm_limit_H: "H (@:ui.hdp/@:ui.ou/@:ui.oe) 12%",
    // comm_limit_I: "I (@:ui.hdp/@:ui.ou/@:ui.oe) 13%",
    // comm_limit_J: "J (@:ui.hdp/@:ui.ou/@:ui.oe) 14%",

    comm_limit_A: "Nhóm A",
    comm_limit_B: "Nhóm B",
    comm_limit_C: "Nhóm C",
    comm_limit_D: "Nhóm D",
    comm_limit_E: "Nhóm E",
    comm_limit_F: "Nhóm F",
    comm_limit_G: "Nhóm G",
    comm_limit_H: "Nhóm H",
    comm_limit_I: "Nhóm I",
    comm_limit_J: "Nhóm J",

    comm_parlay_mmo_a: "Parlay MMO (2-3)",
    comm_parlay_mmo_b: "Parlay MMO (4-12)",

    reset_password: "@:ui.reset @:ui.password",
    edit_password: "@:ui.edit @:ui.password",
    edit_settings: "@:ui.edit @:ui.settings",
    edit_profile: "@:ui.edit @:ui.profile",
    edit_authority: "@:ui.edit @:ui.authority",
    update_commission: "@:ui.update @:ui.commission",
    update_bet_limit: "@:ui.update @:ui.bet_limit",
    update_position_taking: "@:ui.update @:ui.position_taking",
    update_profile: "@:ui.update @:ui.profile",
    update_hdp_packages: "@:ui.update @:ui.hdp_packages",
  },

  downline_id: "Tên cấp dưới",
  disabled: "tên cấp dưới",
  downline: "Tuyến dưới",
  dashboard: "bảng điều khiển",
  downline_list: "Liệt kê tuyến dưới",
  double_chance: "Nhân đôi cơ hội",
  downline_credit: "Tín dụng cấp dưới",
  date: "ngày",
  data: "Dữ liệu",
  date_time: "Ngày và giờ",
  date_range: "Phạm vi ngày",
  details: "Chi tiết",
  draw: "Hoà",
  daily_statement: "Hoà",
  daily_statement_member: "Sao kê hội viên",
  daily_winlose: "Thắng thua ngày",
  daily_winlose_simple: "Thắng thua ngày đơn giản",
  daily_winlose_details: "Thắng thua ngày chi tiết",
  daily_winlose_aio: "Win Lose AIO",
  daily_reset: "Thiết lập lại hàng ngày",
  daily_winlose_platform: "Thắng thua theo dạng thể loại",
  daily_winlose_match: "Thắng thua theo trận",
  detail: "Thắng thua theo trận",
  downline_outstanding: "Mã đang chạy của cấp dưới",
  dd: "Hiệp 1: Hoà | Cả trận: Hoà",
  dh: "Hiệp 1: Hoà | Cả trận: Chủ nhà",
  da: "Hiệp 1: Hoà | Cả trận: Khách",
  dnb: "Hoà không bàn thắng",
  draw_cancel: "Hoà",
  default: "Hoà / Huỷ",

  edit: "Chỉnh sửa",
  enter_information: "Nhập thông tin",
  enable: "Cho phép",
  esports: "Thể thao điện tử",
  edit_account: "Chỉnh sửa tài khoản",
  edit_limit: "Chỉnh sửa giới hạn",
  early: "Sớm",
  event: "Chương trình",
  enabled: "Bật",
  esports_min_bet: "@:ui.esports @:ui.min_bet",
  esports_max_bet: "@:ui.esports @:ui.max_bet",
  esports_max_per_match: "@:ui.esports @:ui.max_per_match",
  even: "Lẻ",
  edited: "Được chỉnh sửa",
  export_excel: "Xuất Excel",

  from: "Từ",
  full: "Đầy",

  forecast: "Dự báo",
  forecast_soccer: "Dự báo (bóng đá)",
  freeze: "Đóng băng",
  full_name: "Họ và tên",
  full_mode: "Dạng tổng",
  first_hdp: "Kèo hiệp 1",
  first_ou: "Tài xỉu hiêpj 1",
  fh: "FH",
  forecast_details: "Chi tiết dự báo",
  full_time: "Cả trận",
  fglg: "@:m.BT_FG/@:m.BT_LG",
  first_goal: "Bàn thắng đầu",
  first_half: "Nửa hiệp 1",

  grand_total: "Tổng cộng",
  gross_commission: "Tổng hoa hồng",
  game_name: "Tên của trò chơi",
  game_provider: "Nhà cung cấp trò chơi",
  game_result: "Kết quả trò chơi",
  game_result_details: "Chi tiết kết quả trò chơi",
  gross_winlose: "Tổng thắng thua",
  game_type: "Dạng trò chơi",

  ht: "HT",
  half: "Một nửa",
  half_time: "Nửa thời gian",
  home: "Trang Chủ",
  hdp: "Trang Chủ",
  hdp_packages: "Gói kèo",
  home_team_name: "Đội Tên",
  home_score: "Điểm về đích",
  hh: "Chủ nhà | FT: Chủ nhà",
  hd: "Chủ nhà | FT: Hoà",
  ha: "Chủ nhà | FT: Khách",
  hdpou: "@:ui.hdp/@:ui.ou",
  htft: "@:ui.half_time/@:ui.full_time",
  hnb: "Chủ nhà không bàn thắng",

  ip_address: "Địa chỉ IP",
  id: "ID",

  key: "Chìa khóa",
  keno: "Keno",
  keno_bet_limit_packages: "Gói giới hạn cược Keno",

  log_id: "Đăng nhập ID",
  lottery: "Xổ số",
  lottery_1d: "Xổ số 1D",
  lottery_2d: "Xổ số 2D",
  lottery_3d: "Xổ số 3D",
  lottery_4d: "Xổ số 4D",
  lotto: "Xổ số",
  log: "Lịch sử",
  list: "Danh sách",
  logs: "Lịch sử",
  login: "Đăng nhập",
  logout: "Đăng xuất",
  login_ip: "Đăng nhập IP",
  login_id: "Đăng nhập ID",
  last_name: "Tên họ",
  live_casino: "Sóng bạc trực tuyến",
  livecasino: "Sóng bạc trực tuyến",
  lastweek: "Tuần trước",
  lastmonth: "Tháng trước",
  last3month: "3 tháng trước",
  league_id: "Tên giải đấu",
  league_name: "Tên giải đấu",
  league: "Giải đấu",
  livecasino_platform: "Nền tảng sóng bài trực tuyến",
  livecasino_upline_pt : "@:ui.live_casino @:ui.upline_pt",
  livecasino_account_pt : "@:ui.live_casino @:ui.account_pt",
  livecasino_upline_remaining : "@:ui.live_casino @:ui.upline_remaining",
  livecasino_account_min : "@:ui.live_casino @:ui.account_min",
  livecasino_bet_limit_packages: "Gói giới hạn cược sòng bài trực tuyến",
  last_goal: "Bàn thắng cuối",
  live: "Trực tiếp",
  lose: "Thua",
  lose_half: "Thua nữa",
  last_week: "Tuần trước",
  last_month: "Tháng trước",
  lotto_bet_limit_packages: "Gói giới hạn cược xổ số",
  lottery_bet_limit_packages: "Gói giới hạn cược xổ số",

  member_log: "Nhật ký thành viên",
  member_balance: "Tín dụng hội viên",
  master_credit: "Tín dụng tổng đại lý",
  member_credit_limit: "Giới hạn tín dụng hội viên",
  max_credit_limit: "Tối đa giới hạn tín dụng",
  min_max_bet: "Tổi thiểu/ Tối đa cược",
  min_bet: "Tối thiểu cược",
  max_bet: "Tối đa cược",
  max_per_match: "Tối đa mỗi trận đấu",
  mix_parlay: "Xiên",
  mmo_parlay: "Myanmar Parlay",
  money_line: "Dòng tiền",
  min: "Tối thiểu",
  max: "Tối đa",
  market_type: "Loại thị trường",
  match_time: "Thời gian trận đấu",
  match_id: "Tên trận",
  member_id: "Tên tài khoản",
  match: "Trận đấu",
  master_outstanding: "Cược chờ tổng đại lý",
  mode: "Chế độ",
  member_outstanding: "Cược chờ hồi viên",
  match_result: "Kết quả trận đấu",
  messages: "Tin nhắn",
  message: "Thông điệp",
  member_management: "Quản lý hội viên",
  member_bulk: "Thành viên số lượng lớn",
  manila_nocomm: "Manila Suite 0% Commission",

  new: "Mới",
  new_login_id: "Tên đăng nhập mới",
  new_username: "Tên đăng nhập mới",
  new_password: "Mật khẩu mới",
  new_security_code: "Mã bảo vệ mới",
  new_account: "Tài khoản mới",
  next: "Kế tiếp",
  no_goal: "Không bàn thắng",
  "no/": "Thứ tự.",
  normal: "Bình thường",
  normal_announcements: "Thông báo bình thường",

  on: "Mở",
  off: "Đóng",
  ok: "đồng ý",
  over: "Kết thúc",
  overview: "Tổng quat",
  old_password: "Mật khẩu cũ",
  outstanding: "Cược chờ",
  outstanding_balance: "Số dư chưa thanh toán",
  over_under: "Tài xỉu",
  odd_even: "OChẵn/Lẻ",
  ou: "Tài xỉu",
  oe: "Chẵn/Lẻ",
  others: "Khác",
  odd: "Chẵn",
  oxt: "1X2",
  outright: "Vô địch",
  others_min_bet: "@:ui.others @:ui.min_bet",
  others_max_bet: "@:ui.others @:ui.max_bet",
  others_max_per_match: "@:ui.others @:ui.max_per_match",
  odds_display: "Hiển thị chẵn",
  online_player: "Người chơi trực tuyến",
  opening_balance: "Tín dụng đầu",
  oxtoeml: "@:m.BT_OE/@:m.BT_1X2/@:m.BT_ML",
  oxthdp: "3 cách kèo chấp",
  others_sports: "Những môn thể thao khác",
  opkey: "OP Key",
  operator_limit: "Operator Limit",

  pending: "Đang duyệt",
  platform: "Nền tảng",
  pt: "Thầu",
  password: "Mật khẩu",
  profile_id: "Hồ sơ ID",
  parent_id: "ID cấp cha",
  page_size: "Kích thước trang",
  profile: "Hồ sơ",
  payment_option: "Phương thức thanh toán",
  part_one: "Phần một",
  part_two: "Phần hai",
  position_taking: "Thầu",
  preview_settings: "Xem trước Cài đặt",
  preview: "Xem trước",
  parlay: "Xiên",
  position_taking_log: "Lịch sử thầu",
  platform_code: "Nền tảng mã",
  platform_name: "Nền tảng tên",
  pay: "Trả / Trả toàn bộ",
  payout: "Thanh toán",
  product: "Sản phẩm",
  pending_matches: "Những Trận Đấu chờ",
  pt_share: "Chia sẽ thầu",
  platform_settings: "Nền tảng Cài đặt",
  parlay_min_bet: "@:ui.parlay @:ui.min_bet",
  parlay_max_bet: "@:ui.parlay @:ui.max_bet",
  parlay_max_per_match: "@:ui.parlay @:ui.max_per_match",
  parlay_upline_pt : "@:ui.parlay @:ui.upline_pt",
  parlay_account_pt : "@:ui.parlay @:ui.account_pt",
  parlay_upline_remaining : "@:ui.parlay @:ui.upline_remaining",
  parlay_account_min : "@:ui.parlay @:ui.account_min",
  personal: "Cá nhân",
  personal_message: "Thông điệp cá nhân",
  password_reset: "Đặt lại mật khẩu",
  password_update: "Mật khẩu cập nhật",

  refresh: "Làm mới",
  reset: "Cài lại",
  remaining_credit: "Tín dụng còn lại",
  remaining: "Còn lại",
  rate: "Tỷ lệ",
  report: "Báo cáo",
  running: "Đang chạy",
  remark: "Chú ý",
  refund: "Hoàn tiền",
  range: "Phạm vi",
  reject: "Từ chối",
  reset_accumulate_win: "Đặt lại tích luỹ thắng",

  status: "Trạng thái",
  succeed: "Thành công",
  submit: "Gửi đi",
  settings: "Cài đặt",
  save: "lưu",
  search: "Tìm kiếm",
  suspend: "Đình chỉ",
  security_tag: "Thẻ bảo mật",
  sub_account: "Tài khoản phụ",
  search_and_copy: "Tìm kiếm và sao chép",
  search_existing: "Tìm kiếm hiện có",
  skip: "Bỏ qua",
  settings_limit: "Cài đặt Giới hạn",
  sportsbook: "Thể thao",
  slot_games: "Trò chơi xèng",
  soccer: "Bóng đá",
  sport_types: "Các loại thể thao",
  settlement: "Thống kê",
  submatch_id: "Sub-match ID",
  score: "Ghi bàn",
  submatch_code: "Sub-match Mã",
  settlement_list: "Danh sách giải quyết",
  sub_total: "Sub Tổng số",
  settle_amount: "Số tiền giải quyết",
  settlement_history: "Lịch sử định cư",
  settlement_member: "Chi tiết giải quyết thành viên",
  sport_type: "Loại thể thao",
  slot_platform: "Nền tẳng trò chơi xèng",
  simple_report: "Báo cáo đơn giản",
  status_update: "Cập nhật trạng thái",
  set_authority: "Cài đặt quyền",
  soccer_hdp_upline_pt : "@:ui.soccer @:ui.hdp @:ui.upline_pt",
  soccer_hdp_account_pt : "@:ui.soccer @:ui.hdp @:ui.account_pt",
  soccer_hdp_upline_remaining : "@:ui.soccer @:ui.hdp @:ui.upline_remaining",
  soccer_hdp_account_min : "@:ui.soccer @:ui.hdp @:ui.account_min",
  soccer_1x2_upline_pt : "@:ui.soccer @:ui.oxt @:ui.upline_pt",
  soccer_1x2_account_pt : "@:ui.soccer @:ui.oxt @:ui.account_pt",
  soccer_1x2_upline_remaining : "@:ui.soccer @:ui.oxt @:ui.upline_remaining",
  soccer_1x2_account_min : "@:ui.soccer @:ui.oxt @:ui.account_min",
  soccer_others_upline_pt : "@:ui.soccer @:ui.others @:ui.upline_pt",
  soccer_others_account_pt : "@:ui.soccer @:ui.others @:ui.account_pt",
  soccer_others_upline_remaining : "@:ui.soccer @:ui.others @:ui.upline_remaining",
  soccer_others_account_min : "@:ui.soccer @:ui.others @:ui.account_min",
  slots_upline_pt : "@:ui.slots @:ui.upline_pt",
  slots_account_pt : "@:ui.slots @:ui.account_pt",
  slots_upline_remaining : "@:ui.slots @:ui.upline_remaining",
  slots_account_min : "@:ui.slots @:ui.account_min",
  soccer_min_bet: "@:ui.soccer @:ui.min_bet",
  soccer_max_bet: "@:ui.soccer @:ui.max_bet",
  soccer_max_per_match: "@:ui.soccer @:ui.max_per_match",
  slots: "Xèng",
  security_update: "Cập nhật bảo mật",
  security_code: "Mã bảo vệ",
  success: "Sự thành công",
  stock: "Cổ phần",
  special: "Đặc biệt",
  special_announcements: "Thông báo đặc biệt",
  seconds: "Giây",
  security_disable: "Bỏ mã bảo vệ",
  select_all: "Chọn tất cả",

  schedule_1: "Thứ hai | Thứ hai",
  schedule_2: "Thứ ba | Thứ ba",
  schedule_3: "Thứ tư | Thứ tư",
  schedule_4: "Thứ năm | Thứ năm",
  schedule_5: "Thứ sáu | Thứ sáu",
  schedule_6: "Thứ bảy | Thứ bảy",
  schedule_7: "Chủ nhật | Chủ nhật",

  twtn: "Lật kèo",
  total_outstanding: "Tổng mã cược đang chạy",
  target_id: "Tên mục tiêu",
  target_action: "Thao tác mục tiêu",
  total: "Toàn bộ",
  types: "Các loại",
  total_goal: "Tổng số bàn thắng",
  tennis: "Quần vợt",
  today: "Hôm nay",
  thisweek: "Tuần này",
  thismonth: "Tháng này",
  transaction_log: "Lịch sử giao dịch",
  total_bet: "Tổng cược",
  transaction_date: "Giao dịch Ngày / giờ",
  transfer_method: "Phương thức chuyển tiền",
  turnover: "Doanh số",
  total_balance: "Tổng tín dụng",
  total_tran: "Tổng số giao dịch",
  total_base: "Tổng cược của hội viên",
  tennis_min_bet: "@:ui.tennis @:ui.min_bet",
  tennis_max_bet: "@:ui.tennis @:ui.max_bet",
  tennis_max_per_match: "@:ui.tennis @:ui.max_per_match",
  top_winner: "Top 10 người thắng của tháng",
  top_turnover: "Top 10 doanh sách lớn nhất của tháng",
  type: "Dạng",
  total_downline: "Tổng cấp dưới",
  to: "Đến",
  transfer: "Hoàn tiền về",
  transfer_list: "Dnh sách hoàn tiền về",
  transfer_history: "Lịch sử hoàn tiền về",
  this_month: "Tháng này",
  this_week: "Tuần này",

  under: "Dưới",
  upline_id: "Tuyến trên ID",
  unblock: "Mở khóa",
  update: "Cập nhật",
  username: "Tên tài khoản",
  update_commission_sb: "Hoa hồng thể thao",
  update_commission_lc: "hoa hồng sòng bạc trực tuyến",
  update_commission_sl: "hoa hồng trò chơi xèng",
  update_commission_lo: "hoa hồng xổ số",
  update_commission_kn: "hoa hồng keno",
  update_commission_cf: "Hoa hồng đá gà",
  update_commission_lt: "Hoa hồng xổ số",
  update_bet_limit_lc: "Giới hạn cược thể thao",
  update_bet_limit_sb: "Giới hạn cược sòng bạc trực tuyến",
  update_bet_limit_lo: "Giới hạn cược xổ số",
  update_bet_limit_kn: "Giới hạn cược keno",
  update_bet_limit_cf: "Giới hạn cược đá gà",
  update_bet_limit_lt: "Giới hạn cược xổ số",
  update_position_sb: "Thầu thể thao",
  update_position_lc: "Thầu sòng bạc trực tuyến",
  update_position_sl: "Thầu trò chơi xèng",
  update_position_lo: "Thầu xổ số",
  update_position_kn: "Thầu keno",
  update_position_cf: "Thầu đá gà",
  update_position_lt: "Thầu xổ số",
  update_account: "Cập nhật tài khoản",
  update_platform: "Cập nhật nền tảng",
  upline_pt: "Thầu cấp trên",
  upline_remaining: "Thầu còn lại",
  unblock_profile: "mở khoá hồ sơ",
  unselect_all: "Bỏ chọn tất cả",

  view_details: "Xem chi tiết",
  view_downline: "Xem cấp dưới",
  value: "Giá trị",
  valid_turnover: "Doanh thu hợp lệ",
  void: "Huỷ",

  winlose_limit: "Giới hạn thắng thua",
  wallet: "Ví tiền",
  winlose: "Thắng thua",
  win_limit: "Giới hạn thắng",
  win_limit_multiplier: "Giới hạn thắng liên tục",
  win_limit_tooltips: "Chỉ áp dụng cho sòng bạc trực tuyến.",
  win_limit_tooltips1: "Do độ trễ API của sòng bạc, người chơi có thể tiếp tục đặt cược trong vài phút sau khi đạt đến Giới hạn thắng.",
  win_limit_0: "Không giới hạn",
  win_limit_1: "Giới hạn tín dụng x 1",
  win_limit_2: "Giới hạn tín dụng x 2",
  win_limit_5: "Giới hạn tín dụng x 5",
  win_limit_10: "Giới hạn tín dụng x 10",
  win_limit_20: "Giới hạn tín dụng x 20",
  winlose_column1: "Thắng/Thua",
  winlose_column2: "Hoa hồng",
  winlose_today: "Thắng thua hôm nay",
  winlose_yesterday: "Thắng thua hôm qua",
  winner: "Người chiến thắng",
  won: "Thắng",
  win_half: "Thắng nửa",

  yesterday: "Hôm qua",
  yesterday_balance: "Tín dụng hôm qua",

  provider_evo: "Trò chơi tiến hoá",
  provider_gp: "Manila suite",
  provider_vivo: "Vegas suite",
  provider_sa: "Bangkok suite",
  provider_ct: "Hanoi suite",
  provider_slots: "Xổ số ",
  provider_lotto: "Lotto",
  provider_keno: "Keno",
  provider_cockfight: "Cuộc đá gà",
  provider_lottery: "Xổ số",

  suffix: "Suffix",
  callback_url: "Callback URL",
  email: "Email",
  seamless: "Seamless",
  key: "Key",
  inactive: "Inactive",

  ip_settings: "IP Settings",
  updated_on: "Updated On",
  updated_by: "Updated By",
  add_ip: "Add IP",
  ip: "IP",
  whitelisted_ip: "Whitelisted IP",
  cash_deposit: "Cash Deposit",
  cash_withdrawal: "Cash Withdrawal",
  fail: "Failed",

  timer: "Hẹn giờ",
  no_refresh: "Không làm mới",
  actual_yesterday_balance: "Số dư thực tế ngày hôm qua",

  bet_limit_default: "Bet Limit Default",
  bet_limit_single: "Bet Limit Single",
  hdp_package: "HDP Package",
  update_hdp_package: "Update HDP Package",
  update_bet_limit_default: "Update Bet Limit Default",
  update_bet_limit_single: "Update Bet Limit Single",

  refno: "Ref No.",
  system_parlay: "Cược xiên hệ thống",
  total_accepted: "Tổng số được chấp nhận",
  total_rejected: "Tổng số bị từ chối",
  total_stake: "Tổng số cổ phần",
  total_winlose: "Tổng số Thắng / Thua",
  fold: "Kết hợp",
  combination: "Combination",

  running_score: "điểm chạy",
  abandoned: "bị bỏ rơi",
};